module.exports = __webpack_public_path__ + "components/flag/static/square/lb-a57d874dafe13da5a68ec32fd9addabb.svg";